import { render, staticRenderFns } from "./games.vue?vue&type=template&id=8aac8cc2&scoped=true&"
import script from "./games.vue?vue&type=script&lang=js&"
export * from "./games.vue?vue&type=script&lang=js&"
import style0 from "./games.vue?vue&type=style&index=0&id=8aac8cc2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aac8cc2",
  null
  
)

export default component.exports